<style lang="less">
    
</style>
<template>
    <v-container>
        <v-row>



            <v-col cols="12" md="2">
                <v-switch v-model="agendaView" color="accent" label="Agenda" class="mr-3"></v-switch>
            </v-col>
            <v-col cols="12" md="6" class="body-2" v-if="!agendaView">
                <v-radio-group v-model="type" color="success" row label="Format: ">
                    <v-radio value="week" label="Week"></v-radio>
                    <v-radio value="month" label="Month"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="12" md="3" class="text-right" v-if="!agendaView">
                <v-btn x-small outlined class="mr-4" color="grey darken-2" @click="setToday">
                Today
                </v-btn>            
                <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="agendaView">

            <Agenda :events="events" v-on:clickEvent="viewAgendaEvent"></Agenda>
        </v-row>
        <div v-else>
            
            <v-sheet height="500">
                <v-calendar
                ref="calendar"
                v-model="focus"
                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                :type="type"
                :events="displayEvents"
                :event-color="getEventColor"
                @click:event="viewEvent"
                @click:more="viewDay"
                @click:day="viewDay"
                event-overlap-mode="stack"
                ></v-calendar>
            </v-sheet>
            <v-row>
                <v-col cols="3" v-if="toggles.length > 1" > 
                    <v-select width="50" v-model="toggle" :items="toggles" label="Filter:"></v-select>
                </v-col>
                <v-col> 
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <h3 v-on="on" class="mw-h3 mb-2">Filter by Project</h3>
                        </template>
                        <span>Toggle display of events and appointments by project title</span>
                    </v-tooltip>
                    <v-btn x-small v-for="(option, i) in toggleOptions[toggle]" :key="i" rounded :color="getOptionColor(option)" dark class="ml-2" @click="hideByOption(option)">{{option}}</v-btn>
                 </v-col>
                 <v-col>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <h3 v-on="on" class="mw-h3 mb-2">Display Team Availability</h3>
                        </template>
                        <span>Toggle display of  the project team’s availability</span>
                    </v-tooltip>
                    <v-btn x-small dark :color="!hideAvailability ? 'green' : 'grey'" rounded class="ml-2" @click="hideAvailability = !hideAvailability">Availability</v-btn>
                 </v-col>
                 <v-col class="text-right" v-if="allowAddAvailability">
                     <v-btn color="success" @click="showAvailabilityDialog = 1">Add my availability</v-btn>
                 </v-col>
            </v-row>

            <v-dialog v-model="showAvailabilityDialog">

                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Availability
                    </v-card-title>

                    <v-card-text>
                        <v-row v-for="(event, i) in availabilityEvents" :key="i">
                            <v-col v-for="(dt, key, i) in event" :key="i">
                                <v-menu v-if="key !== 'name'"
                                :ref="`$menu{i}`"
                                :v-model="`$menu{i}`"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="formattedDate(event,key)"
                                :label="prettyPrint(key, 'TITLE')"
                                :prepend-icon="getCalendarIcon(key)"
                                v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker v-if="key == 'start_date' || key =='end_date'" v-model="event[key]" no-title></v-date-picker>
                                <v-time-picker v-if="key == 'start_time' || key =='end_time'" v-model="event[key]" no-title></v-time-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <p class="text-right">
                            <v-btn color="primary" text @click="availabilityEvents.push({start_date: '', start_time: '', end_date: '', end_time: ''})">Add Line</v-btn>
                        </p>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" dark @click="setAvailability">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <p class="text-left">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                           <v-btn v-on="on" color="accent" @click="downloadCalendar">Export calendar</v-btn>
                        </template>
                        <span>Export calendar in ical format. </span>
                    </v-tooltip>
            
            </p>
        </div>
    </v-container>
</template>

<script type="text/javascript">
    import Vue from "vue";
    import Vuex from 'vuex'
    import {prettyPrint, exportCalendar} from "../../assets/utilities.js";
    import Agenda from "../tools/Agenda.vue"
    export default{
        name: "Calendar", 
        props: {
            allowAddAvailability: {type: Boolean, default: false },
            events: {type: Array},
            toggles: {type: Array,  default: () => []},
            availability: {type: Array, default: () => []},
            calendarName: {type: String, default: "Upcoming appointments - Meisterworks"}
        },
        components: {
            Agenda: Agenda
        },
        data: () => {
            return {
                focus: '',
                type: "month",
                agendaView: false,
                toggle: '',
                hideOptions: [],
                showAvailabilityDialog: 0,
                availabilityEvents: [],
                hideAvailability: false
            }
        },
        computed: {
            ...Vuex.mapState({
                user: function(state) {
                    return state.auth.user   
                },
                view: state => state.auth.view,
                colors: state => state.settings.colors,
            }),
            displayEvents: function(){
                const self = this;
                self.events.forEach( e => {
                    if( self.hideOptions.indexOf( e[self.toggle] ) > -1 ){
                        e.hide = true;
                    } 
                    else{
                        e.hide = false;
                    }
                })
                let events = self.events.filter( e => !e.hide);
                if( !self.hideAvailability ){
                    self.availability.forEach( function(e) {
                        let event = {
                            availability: true, 
                            start: e.start,
                            end: e.end,
                        }
                        if( e.userName ){
                            event.name = e.userName; 
                        }
                        else if(self.user){
                            event.name = self.user.displayName;
                        }
                        else{
                            event.name = "Client/moderator "
                        }
                        if( e.project ){
                            event.name += " for " + e.project ;
                        }

                        events.push(event)
                    })
                }
                return events;
            },
            toggleOptions: function(){
                const self = this;
                let options = {}
                if( !self.toggles ){
                    return;
                }
                self.toggles.forEach( key => {
                    options[key] = [];
                    self.events.forEach( e => {
                        if( e[key] && options[key].indexOf( e[key] ) < 0  ){
                            options[key].push( e[key] )
                        }
                    } )
                })
                return options
            } 
        },
        watch: {
            toggle: function(){
                this.hideOptions = [];
            },
            availability: {
                immediate: true, 
                handler: function(availability){
                    const self = this;
                    this.availabilityEvents = availability.filter(a => a.userId == self.user.uid).map(function(a){
                        let ev = {
                            start_date: a.start.split(" ")[0], 
                            start_time: a.start.split(" ")[1], 
                            end_date: a.end.split(" ")[0], 
                            end_time: a.end.split(" ")[1], 
                        }
                        return ev;
                    });
                }
            }
        },
        methods: {
            prettyPrint: prettyPrint,
            formattedDate(event, key){
              if( !event[key] ){
                return '';
              }
              if( key == 'start_time' || key == 'end_time'){ 
                return event[key];
              }
              else{
                return Vue.moment(event[key]).format('DD/MM/YYYY');
              }
            },
            getOptionColor(option){
                if( this.hideOptions.indexOf( option ) > -1 ){
                    return "grey";
                }
                let i2 = this.toggleOptions[this.toggle].indexOf( option )
                return this.colors[i2]
            },
            hideByOption(option){
                let optionIndex = this.hideOptions.indexOf( option ) 
                if( optionIndex < 0 ){
                    this.hideOptions.push( option )
                }
                else{
                    this.hideOptions.splice( optionIndex, 1 ); 
                }
            },
            getEventColor(event){
                if( event.availability ){
                    return "green";
                }
                if( !event[this.toggle] ){
                    return "grey";
                }
                return this.getOptionColor(event[this.toggle])
            },
            setAvailability(){
               const self = this;
               self.$emit("availabilitySet", this.availabilityEvents);
               self.showAvailabilityDialog = false;
            },
            getCalendarIcon(key){
                if( key.split("_")[1] == 'date' ){ return "mdi-calendar"}
                if( key.split("_")[1] == 'time' ){ return "mdi-calendar-clock"}
                return ""
            },      
            prev () {
                this.$refs.calendar.prev()
            },
            next () {
                this.$refs.calendar.next()
            },
            viewAgendaEvent( event ){
                this.$emit("clickedEvent", event.appointment)
            },
            viewEvent(event){ 
                if( event.event.availability ){ return false; }
                else{
                    this.$emit("clickedEvent", event.event.appointment)
                }    
            },
            setToday () {
                this.focus = this.today
            },
            viewDay ({ date }) {
                this.focus = date
                this.type = 'day'
            },
            downloadCalendar(){
                exportCalendar(this.displayEvents, this.calendarName);
            }
        },
        created: function(){
            this.toggle = this.toggles[0]
        }
    }
</script>